import { Component } from '@angular/core';

@Component({
  selector: 'app-sso-user-guide',
  templateUrl: './sso-user-guide.component.html',
  styleUrls: ['./sso-user-guide.component.scss'],
})
export class SsoUserGuideComponent {
  scrollTo(elementId: string): void {
    const el = document.getElementById(elementId);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
